export default "__VITE_ASSET__12743hke__"